// hooks/useBarColors.ts
import { useMemo } from 'react'

export const useBarColors = (
  data: any[] | undefined,
  dataKey: string,
  palette: string[],
  random: boolean = false
) => {
  return useMemo(() => {
    if (!data || data.length === 0) return []

    // Si random est true, utilise toutes les couleurs de la palette
    if (random) {
      return data.map((_, index) => palette[index % palette.length])
    }

    // Sinon, utilise la logique de dégradé basée sur les valeurs
    const values = data.map((d) => d[dataKey])
    const minValue = Math.min(...values)
    const maxValue = Math.max(...values)

    return data.map((entry) => {
      if (maxValue === minValue) return palette[4]

      const normalized = (entry[dataKey] - minValue) / (maxValue - minValue)
      const colorIndex = Math.min(Math.floor(normalized * 8), 7)

      return palette[colorIndex]
    })
  }, [data, dataKey, palette, random])
}
